import React from 'react';
import { Accordion } from './ui/Accordion';
export function KitContents() {
  const items = [{
    title: '📘 Manual de uso',
    desc: 'Guía paso a paso para implementar todas las herramientas del kit en tu institución.'
  }, {
    title: '🧑‍⚕️ Ficha de Personal — Médicos',
    desc: 'Plantilla completa para registrar datos, especialidades y legajo de profesionales médicos.'
  }, {
    title: '👩‍⚕️ Ficha de Personal — Enfermería',
    desc: 'Registro detallado adaptado a las necesidades y turnos del personal de enfermería.'
  }, {
    title: '🗂️ Ficha de Personal — Administrativo',
    desc: 'Control de legajos para el personal de recepción, facturación y administración.'
  }, {
    title: '🧹 Ficha de Personal — Servicios Generales',
    desc: 'Plantilla para personal de maestranza, mantenimiento y seguridad.'
  }, {
    title: '📋 Control de Matrículas y Habilitaciones',
    desc: 'Sistema con semáforo automático de vencimientos para evitar multas.'
  }, {
    title: '🕐 Planificador de Guardias y Turnos',
    desc: 'Matriz automatizada para organizar esquemas 24/7 sin solapamientos.'
  }, {
    title: '🤒 Control de Ausentismo y Licencias',
    desc: 'Registro centralizado de partes de enfermo, vacaciones y licencias especiales.'
  }, {
    title: '💰 Mapa de Adicionales por Convenio',
    desc: 'Guía clara de los adicionales aplicables según el convenio colectivo de sanidad.'
  }, {
    title: '💉 Capacitaciones Obligatorias y Vacunación',
    desc: 'Seguimiento del calendario de vacunación y cursos de RCP/bioseguridad del personal.'
  }, {
    title: '🦺 EPP y Libretas Sanitarias',
    desc: 'Control de entrega de Elementos de Protección Personal y vigencia de libretas.'
  }, {
    title: '📊 Dashboard General (KPIs automáticos)',
    desc: 'Panel visual con los indicadores clave de recursos humanos de tu clínica.'
  }, {
    title: '📊 Reporte Mensual a Dirección',
    desc: 'Plantilla auto-completada para presentar resultados a la gerencia médica.'
  }, {
    title: '📅 Calendario Anual de Vencimientos',
    desc: 'Vista anual de todas las obligaciones legales y administrativas.'
  }, {
    title: '🆘 Banco de Suplentes',
    desc: 'Base de datos organizada para cubrir ausencias de último momento.'
  }, {
    title: '🆕 Onboarding — Checklist de Ingreso',
    desc: 'Paso a paso para asegurar que el nuevo empleado tenga todo listo en su primer día.'
  }, {
    title: '🆕 Onboarding — Carta de Bienvenida',
    desc: 'Modelo profesional para recibir a los nuevos talentos de la institución.'
  }, {
    title: '📞 Directorio de Contactos Críticos',
    desc: 'Plantilla para tener a mano números de emergencia, derivaciones y proveedores clave.'
  }, {
    title: '🆕 Onboarding — Planilla de Entrega de Elementos',
    desc: 'Documento legal para respaldar la entrega de uniformes, credenciales y llaves.'
  }, {
    title: '🧮 Liquidador de Adicionales y Sueldo (BONUS)',
    desc: 'Herramienta avanzada para pre-liquidar sueldos con adicionales de sanidad.'
  }];
  return <section className="py-12 px-4" data-id="element-131">
      <div className="max-w-lg mx-auto" data-id="element-132">
        <div className="text-center mb-8 bg-white/90 backdrop-blur-sm rounded-2xl p-5 shadow-lg" data-id="element-133">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3" data-id="element-134">
            Sabemos lo complicado que es, por eso fabricamos este kit.
          </h2>
          <p className="text-slate-600" data-id="element-135">
            Todo lo que necesitas para profesionalizar tu área de RRHH, en un
            solo lugar.
          </p>
        </div>

        <div className="mb-8" data-id="element-136">
          {items.map((item, idx) => <Accordion key={idx} title={item.title} defaultOpen={idx === 0} data-id="element-137">
              <p data-id="element-138">{item.desc}</p>
            </Accordion>)}
        </div>
      </div>
    </section>;
}